function normalizeStringValue(value) {
  if (typeof value !== 'string') {
    return value === null || value === undefined ? null : String(value).trim() || null
  }

  const normalized = value.trim()
  return normalized || null
}

function assignIfPresent(target, key, value) {
  const normalized = normalizeStringValue(value)
  if (normalized !== null) {
    target[key] = normalized
  }
}

function firstDefined(...values) {
  return values.find((value) => value !== undefined && value !== null && value !== '')
}

export function buildCancelPayload(payload = {}) {
  const requestPayload = {}
  assignIfPresent(requestPayload, 'reason', payload?.reason)
  assignIfPresent(requestPayload, 'minuteNo', payload?.minuteNo)
  assignIfPresent(requestPayload, 'minuteDate', payload?.minuteDate)
  return requestPayload
}

export function normalizeCanonicalAdjustPayload(payload = {}) {
  const source = payload && typeof payload === 'object' ? payload : {}
  const requestPayload = {}

  const adjustmentType = Number(firstDefined(source.adjustmentType, null))
  if (Number.isFinite(adjustmentType) && adjustmentType > 0) {
    requestPayload.adjustmentType = adjustmentType
  }

  assignIfPresent(requestPayload, 'reason', source.reason)

  if (Array.isArray(source.items)) {
    requestPayload.items = source.items
  }

  assignIfPresent(requestPayload, 'buyerName', source.buyerName)
  assignIfPresent(requestPayload, 'buyerTaxCode', source.buyerTaxCode)
  assignIfPresent(requestPayload, 'buyerAddress', source.buyerAddress)
  assignIfPresent(requestPayload, 'minuteNo', source.minuteNo)
  assignIfPresent(requestPayload, 'minuteDate', source.minuteDate)

  return requestPayload
}

export function normalizeCanonicalReplacePayload(payload = {}) {
  const source = payload && typeof payload === 'object' ? payload : {}
  const requestPayload = {}

  assignIfPresent(requestPayload, 'reason', source.reason)

  if (Array.isArray(source.items)) {
    requestPayload.items = source.items
  }

  assignIfPresent(requestPayload, 'buyerName', source.buyerName)
  assignIfPresent(requestPayload, 'buyerTaxCode', source.buyerTaxCode)
  assignIfPresent(requestPayload, 'buyerAddress', source.buyerAddress)
  assignIfPresent(requestPayload, 'minuteNo', source.minuteNo)
  assignIfPresent(requestPayload, 'minuteDate', source.minuteDate)

  return requestPayload
}

export function buildResendEmailPayload(payload = {}) {
  const requestPayload = {}
  assignIfPresent(requestPayload, 'email', payload?.email)
  return requestPayload
}
